import React, { useState, useEffect } from "react";
import UtilityCardInfo from "../components/UtilityCardInfo";

const Section3 = ({ contenuti, cards }) => {
  const [isMobile, setIsMobile] = useState(false);


  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      {contenuti.map((content, index) => {
        const { titolo1, titolo2, immagineBg } = content;
        return (
          <div key={index}>
            <div
              className="container-fluid d-flex flex-column align-items-center justify-content-start position-relative"
              style={{
                padding: "76px 16px",
                gap: "16px",
                backgroundImage: 'var(--bg-light-theme)',
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            >
              <div className="position-absolute w-100 head-onda reverse">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 1440 50"
                  preserveAspectRatio="none"
                  className="w-100"
                >
                  <path
                    fill="#fff" // Colore di Bootstrap bg-light
                    d="M0,50L80,45C160,40,320,30,480,25C640,20,800,20,960,25C1120,30,1280,40,1360,45L1440,50L1440,50L1360,50C1280,50,1120,50,960,50C800,50,640,50,480,50C320,50,160,50,80,50L0,50Z"
                  ></path>
                </svg>
              </div>
              <div className="container">
                <div className="title-section text-center">
                  <h2 className={`black-text ${isMobile ? 'd-block d-lg-none title-section-mobile' : 'd-none d-lg-block title-section'}`}>
                    {titolo1}
                  </h2>
                  <h2 className={`green-text ${isMobile ? 'd-block d-lg-none title-section-mobile' : 'd-none d-lg-block title-section'}`} >{titolo2}</h2>
                </div>

                {/* Grid Container */}
                <div className="d-flex">
                  <div className="row container">
                    {/* Mappa delle immagini e dei dati per ogni card */}
                    {cards?.map((card, index) => {
                      const { immagine, titolo, descrizione, callToAction, link } = card;
                      return (
                        <div key={index} className="col-12 col-md-6">
                          <UtilityCardInfo
                            img={immagine}
                            title={titolo}
                            text={
                              <span
                                dangerouslySetInnerHTML={{ __html: descrizione }}
                              />
                            }
                            target={1}
                            buttonText={callToAction}
                            buttonTo={link}
                            buttonClass="btn btn-three"
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
              <div className="position-absolute w-100 foot-onda-reverse">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 1440 50"
                  preserveAspectRatio="none"
                  className="w-100"
                >
                  <path
                    fill="#fff" // Colore di Bootstrap bg-light
                    d="M0,50L80,45C160,40,320,30,480,25C640,20,800,20,960,25C1120,30,1280,40,1360,45L1440,50L1440,50L1360,50C1280,50,1120,50,960,50C800,50,640,50,480,50C320,50,160,50,80,50L0,50Z"
                  ></path>
                </svg>
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default Section3;
